import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect the legacy /blog index to the localized English blog (SEO-008).
// English is the primary SEO target; most inbound links use English content.
export const Route = createFileRoute("/blog/")({
  beforeLoad: () => {
    // 301, not the default 307: this move is permanent, and a temporary redirect
    // leaves the old URL sitting in Search Console as "Page with redirect" for good.
    throw redirect({
      to: "/$lang/blog",
      params: { lang: "en" },
      replace: true,
      statusCode: 301,
    });
  },
  component: () => null,
});
